import React from 'react';
import { Drawer, DrawerContent, DrawerClose } from '@/src/components/ui/drawer';
import { IoCloseSharp } from 'react-icons/io5';
import styles from './GameInfo.module.css';
import { useGameDefinition } from '@/src/hooks/data/useGameTable';
import { RUPEE_SYMBOL } from '@/Poker/data/Constants';
import { returnGameTypeText } from '@/Common/utils/PokerUtils';

export default function GameInfo({ open, onOpenChange, tempTableId }) {
    const gameDefinition = useGameDefinition(tempTableId);

    if (!gameDefinition) return null;

    // TODO: Remove this mock data and replace with actual data from the server
    const gameInfo = [
        { label: 'Game Type', value: returnGameTypeText(gameDefinition.gameType) },
        { label: 'Room Name', value: gameDefinition.roomName },
        { label: 'Table Name', value: gameDefinition.tableName },
        { label: 'Table Timer', value: gameDefinition.tableTime + 's' },
        { label: 'Blinds', value: gameDefinition.smallBlind + ' / ' + gameDefinition.bigBlind },
        { label: 'Max Players', value: gameDefinition.maxPlayers },
        { label: 'Buy-in', value: RUPEE_SYMBOL + gameDefinition.minBuyInAmount + ' - ' + RUPEE_SYMBOL + gameDefinition.maxbuyInAmount },
        { label: 'Run It Twice (RIT)', value: gameDefinition.isRITEnabled ? 'Enabled' : 'Disabled' },
        { label: 'Rake', value: gameDefinition.rake + '%' },
        { label: 'Pre-flop Rake', value: gameDefinition.preflopRake + '%' },
        { label: 'Pre-flop Rake (<=3)', value: gameDefinition.prefloprakeCapForPlayersLETo3 + '%' },
        { label: 'Pre-flop Rake (>3)', value: gameDefinition.preflopRakeCapForPlayersGT3 + '%' },
        { label: 'HU Rake', value: gameDefinition.headsUpRake + '%' },
        { label: 'HU Rake Preflop', value: gameDefinition.preFlopHeadsUpRake + '%' },
        {
            label: 'Preflop Rake Cap (Players <= 3)', value: gameDefinition.prefloprakeCapForPlayersLETo3
        },
        {
            label: 'Preflop Rake Cap (Players > 3)', value: gameDefinition.preflopRakeCapForPlayersGT3
        },
        {
            label: 'Rake Cap (Players <= 3)', value: gameDefinition.rakeCapForStartPlayersLETo3
        },
        {
            label: 'Rake Cap (Players > 3)', value: gameDefinition.rakeCapForStartPlayersGT3
        }
    ]

    return (
        <Drawer open={open} onOpenChange={onOpenChange}>
            <DrawerContent className={styles.container}>
                <div className={styles.drawerHeader}>
                    <DrawerClose asChild>
                        <IoCloseSharp className={styles.drawerClose} />
                    </DrawerClose>
                    <h2 className={styles.drawerTitle}>Game Information</h2>
                </div>
                <div className={styles.drawerContent}>
                    {gameInfo.map((item, idx) => (
                        <div className={styles.infoRow} key={idx}>
                            <span className={styles.label}>{item.label}:</span>
                            <span className={styles.value}>{item.value}</span>
                        </div>
                    ))}
                </div>
            </DrawerContent>
        </Drawer>
    );
}
